import React from 'react';
import PropTypes from 'prop-types';

const TransactionOwnerTag = ({ owner }) => {
  let bgColor = 'bg-gray-200';
  let textColor = 'text-gray-800';
  let label = 'Unknown';

  switch (owner) {
    case 'personal':
      bgColor = 'bg-indigo-100';
      textColor = 'text-indigo-800';
      label = 'Personal';
      break;
    case 'partner':
      bgColor = 'bg-pink-100';
      textColor = 'text-pink-800';
      label = 'Partner';
      break;
    case 'joint':
      bgColor = 'bg-purple-100';
      textColor = 'text-purple-800';
      label = 'Joint';
      break;
    default:
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
      label = 'Unknown';
  }

  return (
    <span 
      className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${bgColor} ${textColor}`}
    >
      {label}
    </span>
  );
};

TransactionOwnerTag.propTypes = {
  owner: PropTypes.oneOf(['personal', 'partner', 'joint', '']),
};

TransactionOwnerTag.defaultProps = {
  owner: '',
};

export default TransactionOwnerTag; 